(function ($, njm) {
    'use strict';

    njm.views.microHeader = Backbone.View.extend({

        events: {
            'click .nav_toggle': 'onNavToggleClick'
        },

        navOpen: false,

        /**
         * On nav toggle click
         * @param ev
         */
        onNavToggleClick: function (ev) {
            var $navToggle = $(ev.currentTarget);

            this.navOpen = !this.navOpen;
            $navToggle.toggleClass('active', this.navOpen);
            this.$('.navigation').toggleClass('active', this.navOpen);
        }
    });
})(jQuery, njm);
